import React from "react";
import { Marker, Popup } from "react-leaflet";
import { NETSTAT_SWITCH_URL, SERVICE_HOUSE_URL } from "../../Optics/OpticApiConfig";
import { icon100pab } from "../../Optics/Constants/ConstantsOptics";


const SwitchMarkers = ({ switches }) => {
  return (
    <>
      {switches.map((sw, index) => (
        <Marker
          key={`switch-${index}`}
          position={[sw.latitude, sw.longitude]}
          icon={icon100pab}
        >
          <Popup className="custom-popup-auto-topo">
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
              }}
            >
              <img
                src="./sw.png"
                width="40"
                height="40"
                style={{ marginBottom: "5px" }}
                alt="Switch"
              />
            </div>

            <span style={{ fontWeight: "bold", color: "#fabf66ff" }}>Адрес:</span>{" "}
            <a
              href={`${SERVICE_HOUSE_URL}?Id=${sw.hid}`}
              target="_blank"
              rel="noreferrer"
              style={{ fontWeight: "bold", color: "#d1d1d1" }}
            >
              {sw.street}, дом. {sw.house}
            </a>
            <br />
            <span style={{ fontWeight: "bold", color: "#fabf66ff" }}>Подъезд:</span>
            <span style={{ color: "#d1d1d1" }}> {sw.entrance}</span>
            <br />

            <hr
              style={{
                color: "#ffffffff",
                marginTop: "5px",
                marginBottom: "10px",
              }}
            />

            <div
              className="custom-box-telecom-auto-topo"
              style={{ marginBottom: "3px" }}
            >
              <span style={{ fontWeight: "bold", fontSize: "12px" }}>Модель:</span>{" "}
              <span style={{ fontSize: "12px" }}>{sw.model}</span>
              <br />
              <span style={{ fontWeight: "bold", fontSize: "12px" }}>Ip:</span>{" "}
              <span style={{ fontSize: "12px" }}>
                <a
                  href={`${NETSTAT_SWITCH_URL}?ip=${sw.ip}`}
                  target="_blank"
                  rel="noreferrer"
                  style={{ fontWeight: "bold", color: "#005fb8" }}
                >
                  {sw.ip}
                </a>
              </span>
              <br />
              <span style={{ fontWeight: "bold", fontSize: "12px" }}>Mac:</span>{" "}
              <span style={{ fontSize: "12px" }}>{sw.mac}</span>
              <br />
            </div>
          </Popup>
        </Marker>
      ))}
    </>
  );
};

export default SwitchMarkers;